export interface Country {
    code: string;
    name: string;
    dialCode: string;
    flagImg: string;
  }
  
  export const COUNTRIES: Country[] = [
    {
      code: 'KR',
      name: '한국',
      dialCode: '(+82)',
      flagImg: 'img/flag_kr.png',
    },
    {
      code: 'US',
      name: '미국',
      dialCode: '(+1)',
      flagImg: 'img/flag_us.png',
    },
    {
      code: 'CN',
      name: '중국',
      dialCode: '(+86)',
      flagImg: 'img/flag_cn.png',
    },
    {
      code: 'JP',
      name: '일본',
      dialCode: '(+81)',
      flagImg: 'img/flag_jp.png',
    },
    {
      code: 'SGP',
      name: '싱가포르',
      dialCode: '(+65)',
      flagImg: 'img/flag_sgp.png',
    },
    {
      code: 'TP',
      name: '태국',
      dialCode: '(+66)',
      flagImg: 'img/flag_tp.png',
    },
    {
      code: 'INDN',
      name: '인도네시아',
      dialCode: '(+62)',
      flagImg: 'img/flag_indn.png',
    },
    {
      code: 'UK',
      name: '영국',
      dialCode: '(+44)',
      flagImg: 'img/flag_uk.png',
    },
    {
      code: 'AUS',
      name: '호주',
      dialCode: '(+61)',
      flagImg: 'img/flag_aus.png',
    },
    {
      code: 'FR',
      name: '프랑스',
      dialCode: '(+33)',
      flagImg: 'img/flag_fr.png',
    },
    {
      code: 'DE',
      name: '독일',
      dialCode: '(+49)',
      flagImg: 'img/flag_de.png',
    },
    {
      code: 'BR',
      name: '브라질',
      dialCode: '(+55)',
      flagImg: 'img/flag_br.png',
    },
    {
      code: 'IT',
      name: '이탈리아',
      dialCode: '(+39)',
      flagImg: 'img/flag_it.png',
    },
    {
      code: 'IN',
      name: '인도',
      dialCode: '(+91)',
      flagImg: 'img/flag_in.png',
    },
    {
      code: 'ZA',
      name: '남아프리카공화국',
      dialCode: '(+27)',
      flagImg: 'img/flag_za.png',
    }
    // 필요한 국가 계속 추가
  ];